require("../../../static/js/main_etf.js");
